import { timeSlotDef, durationOptions, apiRequestsConstants } from './../../utils/spaConstants'
import { servicesCategoryMap } from '../../components/SpaServices/servicesConstants'
import {
    setServiceCategories,
    itemsFetchDataSuccess,
    setCruiseDates,
    fetchedBookingDetails,
    fetchedReservedServices,
    setItenaryDetails,
    setCPNavMenuData,
    getCPNavigationHeader,
    setAuthTokenDetails,
    showSpaError,
    getItinerary,
    selectServiceFromId,
    setDaysToCruise
} from '../spaServices.actions'
import { setCartData } from '../reservation.actions';
import moment from 'moment'
import sortBy from 'lodash/sortBy';
import values from 'lodash/values';
import uniqBy from 'lodash/uniqBy';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import startsWith from 'lodash/startsWith';


export const getCancelReqBody = (selectedService = {}, _state) => {
    let _reqBody = apiRequestsConstants['sendRequestCancelBooking']
    _reqBody.POLARRequest.AS06Q_Cancel_Spa_Appts.Booking.BookingNumber =
        _state.services.bookingDetails.BookingNumber
    _reqBody.POLARRequest.AS06Q_Cancel_Spa_Appts.Guest.PaxId = selectedService.paxId
    _reqBody.POLARRequest.AS06Q_Cancel_Spa_Appts.Guest.SpaAppointments.ResHoldId =
        selectedService.appointment.ResHoldId
    return _reqBody
}

export const getSteinerCancelReqBody = (selectedService = {}, _state) => {
    let _reqBody = apiRequestsConstants['cancelSteinerReservation']
    _reqBody.ResHoldId = '' + selectedService.appointment.ResHoldId;
    _reqBody.VesselID = _state.services.bookingDetails.Product.Cruise.Voyage.Ship.Id
    return _reqBody
}

export const getReqBody = (filter = {}, services) => {
    let reqBody = {}
    reqBody.Category = servicesCategoryMap[filter.selectedCategory] || filter.selectedCategory || '';
    reqBody.StartDate = filter.startDate
    reqBody.EndDate = filter.endDate
    reqBody.Benefit = filter.selectedBenefit || '';
    if (filter.selectedTimeSlot) {
        let _time = getStartTime(filter.selectedTimeSlot)
        reqBody.ServiceStartTime = _time.startTime
        reqBody.ServiceEndTime = _time.endTime
    }
    if (filter.selectedDuration) {
        if (filter.selectedDuration === 'Any')
            reqBody.Duration = ''
        else {
            let duration = durationOptions.find((dr) => dr.label === filter.selectedDuration)
            reqBody.Duration = duration.value
        }
    }
    reqBody['VesselId'] = services.bookingDetails.vesselId;
    return reqBody
}

export const processBookingDetails = (items, dispatch, getState) => {
    let guestDetails = items.AS01R_Retrieve_Spa_Appts.Guest
    let { Booking, PaymentDetails = false } = items.AS01R_Retrieve_Spa_Appts
    Booking.vesselId = Booking.Product.Cruise.Voyage.Ship.Id
    let { services } = getState()
    let reservations = []
    let guestName = []
    let { contentFeedData = false } = services

    if (guestDetails.length > 0) {
        guestDetails.forEach((item) => {
            guestName.push(item.PassengerDetail.Name)
            item.SpaAppointments.forEach((appointment) => {
                let reservation = {}
                reservation.paxId = item.PaxId
                reservation.PassengerDetail = item.PassengerDetail
                reservation.appointment = appointment
                if (contentFeedData) {
                    let contentData = contentFeedData.find(
                        (data) => data.productCode == appointment.SpaId
                    )
                    reservation.appointment.treatmentName = contentData
                        ? contentData.productName
                        : ''
                }
                reservation.appointment.formatedTime = appointment.ServiceTime
                    ? moment(appointment.ServiceTime, 'HHmm').format('LT')
                    : ''
                reservation.appointment.formatedDate = appointment.ServiceDate
                    ? moment(appointment.ServiceDate, 'YYYYMMDD').format('MMM DD')
                    : ''
                //console.log(reservation);
                reservations.push(reservation)
            })
        })
    }
    let name = guestDetails[0].PassengerDetail.Name
    let bookingNum = Booking.BookingNumber
    let refreshToken = 'SPTRRXP' + Booking.BookingNumber;
    let bookingCatagory = Booking.Category;
    let { authDetails } = services;
    authDetails.refreshToken = refreshToken;
    dispatch(setAuthTokenDetails(authDetails));
    dispatch(getCPNavigationHeader(name.FirstName, name.LastName, bookingNum))
    dispatch(fetchedReservedServices(reservations, items))
    dispatch(fetchedBookingDetails(guestDetails, Booking, guestName, PaymentDetails, bookingCatagory))
    dispatch(getItinerary());
    // dispatch(setCruiseDates(Booking.Product.Cruise.StartDate, Booking.Product.Cruise.EndDate))
}

export const processServices = (items, dispatch, _filter, getState, SpaId, selectedSort) => {

    let availableServices =
        items.reqBookableServicesResult.availableServices.availableService.availableService
    if(selectedSort!==undefined && selectedSort!=='Any'){
        console.log("selectedSort value: " + selectedSort);
        availableServices = getSortedResults(selectedSort, availableServices);
    }
    let { services } = getState()
    let { contentFeedData = [], filter } = services
    let mergedServices = availableServices.map((service) => {
        // eslint-disable-next-line eqeqeq
        let conFeed = contentFeedData.find((content) => content.productCode == service.treatmentId)
        if (conFeed) return { ...service, ...conFeed }
        return service
    })
    if (filter.selectedGuestDetails && filter.selectedGuestDetails.PassengerDetail) {
        if (filter.selectedGuestDetails.PassengerDetail.Age < 18 && filter.selectedGuestDetails.PassengerDetail.Age > 12) {
            mergedServices = mergedServices.filter(service => service.serviceGroup === 'zspaervicesforteens' || service.serviceGroup === 'zspaforteens')
        }
    }

    dispatch(itemsFetchDataSuccess(mergedServices))
    if (SpaId)
        dispatch(selectServiceFromId(SpaId, mergedServices));
    let categories = getCategories(availableServices)
    if (!services.Categories || services.Categories.length === 0)
        dispatch(setServiceCategories(categories))
}

export const getSortedResults = (selectedSort, services) => {
    switch (selectedSort) {
        case 'Price Low to High':
            return sortBy(services, 'price')
        case 'Price High to Low':
            return sortBy(services, 'price').reverse()
        case 'Duration':
            return sortBy(services, 'duration')
        case 'Treatment Name':
            return sortBy(services, 'treatmentDesc')
        default:
            return selectedSort
    }
}

export const getStartTime = (timeSlot) => {
    if (timeSlot === 'Any') return { startTime: '', endTime: '' }

    let _timeSeleted = timeSlotDef[timeSlot]
    if (_timeSeleted)
        return _timeSeleted
    else {
        let startTime = moment(timeSlot, 'HH:mm A').format('HHmm')
        let endTime = moment(timeSlot, 'HH:mm A')
            .add('59', 'minutes')
            .format('HHmm')
        return { startTime: startTime, endTime: endTime }
    }
}

export const setItinerary = (items, dispatch) => {
    if (items && items.length > 0) {
        let itineraryMap = items.map((itinerary) => {
            let _map = {}
            _map.date = itinerary.arrivalDt
            _map.portName = itinerary.portName
            return _map
        })

        dispatch(setItenaryDetails(items, itineraryMap))
    }
}

export const getCategories = (services) => uniqBy(services, 'serviceGroup')

export const processCPNavData = (items, dispatch) => {
    let nav_menu = items['nav-menu']
    if (nav_menu) {
        dispatch(setCPNavMenuData(nav_menu))
    }
}

export const getSteinerCommitReq = (services, cart) => {
    let cartItemsReq = cart.map((cartDataItem) => {

        let _reqbody = {};
        _reqbody.ResHoldId = cartDataItem.resHoldId;
		_reqbody.EmailAddress = services.payer.Email;
        _reqbody.VesselID = services.bookingDetails.vesselId;
        _reqbody.Service = cartDataItem.treatmentId;
        _reqbody.PassengerID = services.bookingDetails.BookingNumber + cartDataItem.PaxId;
        _reqbody.PaxAge = cartDataItem.PassengerDetail.Age;
        _reqbody.PaxFirstName = cartDataItem.PassengerDetail.Name.FirstName;
        _reqbody.PaxGender = cartDataItem.PassengerDetail.Gender;
        _reqbody.PaxLastName = cartDataItem.PassengerDetail.Name.LastName;
        _reqbody.PartnerId = 'PCL';
        _reqbody.ReqDate = moment(new Date()).format('YYYYMMDD');
        _reqbody.PaxCabin = services.bookingDetails.Category.Cabin.Id;
        _reqbody.Currency = services.PaymentDetails.ShipboardCurrencyCode;
        _reqbody.PaymentReceived = cartDataItem.treatmentPrice;
        _reqbody.TreatmentPrice = cartDataItem.treatmentPrice;

        return _reqbody;
    })

    return cartItemsReq;
}

export const getPolarPaymentReq = (services, cart) => {
    let _reqbody = cloneDeep(apiRequestsConstants['sendRequestAddBooking']);
    let cartPrice =
        !cart || cart.length === 0
            ? 0
            : cart.reduce((sum, cartItem) => sum + cartItem.treatmentPrice, 0)

    let { payer = {}, PaymentDetails = {} } = services;

    _reqbody.POLARRequest.AS05Q_Add_Spa_Appts.Booking.BookingNumber =
        services.bookingDetails.BookingNumber
    let groupedCart = groupBy(cart, 'PaxId')
    let guests = values(groupedCart).map((appointments) => {
        let guestAppointments = {}
        guestAppointments.PaxId = appointments[0].PaxId
        guestAppointments.SpaAppointments = appointments.map((appointment) => {
            let _spaObj = {}
            _spaObj.SpaId = appointment.treatmentId
            _spaObj.ResHoldId = appointment.resHoldId
            //TO DO
            _spaObj.SpaType = ''
            _spaObj.ServiceDate = appointment.serviceDate
            let reqTime = moment(appointment.serviceTime, 'HHmm').format('HHmm');
            if (reqTime === 'Invalid date')
                reqTime = moment('0' + appointment.serviceTime, 'HHmm').format('HHmm')
            _spaObj.ServiceTime = reqTime
            _spaObj.Duration = appointment.duration
            _spaObj.TreatmentPrice = appointment.treatmentPrice
            _spaObj.SteinerPrice = appointment.treatmentPrice
            _spaObj.DiscountAmount = '0'
            _spaObj.PaymentStatus = 'P'
            return _spaObj
        })
        return guestAppointments
    })
    let Address = {}
    let Name = {}
    let personalDetails = {}
    let CreditCard = {}
    let S3ds = {}
    if (payer.paymentType === 'credit-card') {
        Address.City = payer.City;
        Address.CountryId = payer.countryCode;
        Address.Housename = payer.Housename;
        Address.Line1 = payer.Address;
        Address.Line2 = payer.Address2 || '';
        Address.Line3 = payer.Address3 || '';
        Address.PostCode = payer.PostCode;
        Address.StateId = payer.stateCode;
        Name.FirstName = payer.FirstName;
        Name.LastName = payer.LastName;
        personalDetails.Address = Address;
        personalDetails.Name = Name;
        CreditCard.CVVEncrypted = ''
        CreditCard.CardBrand = payer.cardType; 
	    // CreditCard.CardExpDt = `${payer.expMonth}${payer.expYear}` //'0320'
	    CreditCard.CardExpDt = ' '

        //TO DO
        CreditCard.GatewayMID = PaymentDetails.CreditCard.GatewayMID;
        CreditCard.MCAPIVersion = PaymentDetails.CreditCard.MCAPIVersion;
        CreditCard.MaskedNumber = payer.maskedCardNumber;
        CreditCard.String = payer.CardNumber;
        CreditCard.StringType = payer.cardStringType;
        CreditCard.FundingMethod = payer.fundsType;
        CreditCard.PersonalDetail = personalDetails;
        // 3DS data
        S3ds.MCOrderId = PaymentDetails.CreditCard.MCOrderId;
        S3ds.MCTransId = Date.now();
        _reqbody.POLARRequest.AS05Q_Add_Spa_Appts.PaymentDetails.CreditCard = CreditCard;
        _reqbody.POLARRequest.AS05Q_Add_Spa_Appts.PaymentDetails.S3ds = S3ds;
    } else {
        let { payPalPayInfo = {} } = services;
        Name.FirstName = payPalPayInfo.details.firstName;
        Name.LastName = payPalPayInfo.details.lastName;
        Address.Line1 = payPalPayInfo.details.billingAddress.streetAddress;
        Address.City = payPalPayInfo.details.billingAddress.locality;
        Address.StateId = payPalPayInfo.details.billingAddress.region;
        Address.CountryId = payPalPayInfo.details.billingAddress.countryCodeAlpha2;
        Address.PostCode = payPalPayInfo.details.billingAddress.postalCode
        personalDetails.Address = Address;
        personalDetails.Name = Name;
        CreditCard.PersonalDetail = personalDetails
        _reqbody.POLARRequest.AS05Q_Add_Spa_Appts.PaymentDetails.CreditCard = CreditCard
        _reqbody.POLARRequest.AS05Q_Add_Spa_Appts.PaymentDetails.PaypalNonce = payPalPayInfo.nonce;
    }

    _reqbody.POLARRequest.AS05Q_Add_Spa_Appts.Guest = guests
    _reqbody.POLARRequest.AS05Q_Add_Spa_Appts.PaymentDetails.PaymentAmount = cartPrice

    let steinerReq = getSteinerCommitReq(services, cart)
    //console.log(steinerReq)
    let paymentReq = {
        POLARRequest: _reqbody.POLARRequest,
        commitRequest: steinerReq,
    }

    return paymentReq
}

//TO DO
export const getBookingsHeader = (authDetails) => {
    let headerObj = {}
    headerObj.ProductCompany = 'PC'
    headerObj.BookingCompany = authDetails.bookingCompany;
    headerObj.AuthToken = authDetails.refreshToken || authDetails.AuthToken;
    headerObj.AppId = 'SPA-' + authDetails.AuthToken;
    headerObj['pcl-client-id'] = authDetails.pclClientId;
    return headerObj
}

export const processItineraryData = (items, dispatch) => {
    let cruiseData = items.cruises[0].itineraries;
    let portsData = items.ports;
    let startDate = (cruiseData[0]) ? cruiseData[0].arrivalDt : '';
    let endDate = cruiseData[cruiseData.length - 2].arrivalDt;
    let daysToCruise = moment(startDate).diff(moment(new Date()), 'days');
    dispatch(setCruiseDates(startDate, endDate));
    dispatch(setDaysToCruise(daysToCruise));
    let ItineraryData = cruiseData.map((onDate) => {
        let portName = ''
        if (!onDate.id) portName = 'At Sea'
        else {
            let onPort = portsData.find((port) => onDate.id.includes(port.id))
            portName = onPort.name || '';
        }
        return { ...onDate, portName }
    });
    return ItineraryData;
}

export const processPaymentResponse = (response, cart, dispatch) => {
    //debugger;
    if (response.polarAddResponse && response.polarAddResponse.POLARResponse) {
        let advCode = response.polarAddResponse.POLARResponse.RespMsgHeader.RespStatus.Advisory[0].ReasonCode;
        if (startsWith(advCode, '0') || startsWith(advCode, '1') || startsWith(advCode, '2')) {
            console.log('Success');
            return ({ status: 'Success', type: 'Success', Msg: '' })
        } else {
            if (response.resHoldIdStatus) {
                let newCart = cart.map((cartItem) => {
                    let newResHoldObj = response.resHoldIdStatus.find(newIds => cartItem.resHoldId == newIds.OldResHoldId);
                    if (newResHoldObj)
                        cartItem.resHoldId = newResHoldObj.NewResHoldId;
                    return cartItem;
                })
                dispatch(setCartData(newCart));
            }
            dispatch(showSpaError('Payment Failed...!'));
            return ({ status: 'error', type: 'POLAR_FAILURE', msg: 'Unable to process payment. Please try again' })
        }
    } else {
        if (response.resHoldIdStatus) {
            let newCart = [];
            let removedItems = [];
            cart.forEach((cartItem) => {
                let newHold = response.resHoldIdStatus.find((newHoldObj) =>
                    (newHoldObj && newHoldObj.OldResHoldId == cartItem.resHoldId)
                );
                if (newHold) {
                    cartItem.resHoldId = newHold.NewResHoldId;
                    newCart.push(cartItem);
                } else {
                    removedItems.push(cartItem);
                }
            })
            let removedAlertMsgs = removedItems ? removedItems.map((removedItem) => {
                return (`${removedItem.treatmentDesc} on ${removedItem.formattedDate} at ${removedItem.formattedTime} `)
            }) : [];
            dispatch(setCartData(newCart));
            dispatch(showSpaError('Payment Failed...!'));
            return ({ status: 'error', type: 'OSW_PAR_FAILURE', msg: 'Reservation is not available for One or More Items. Please Try Again for Updated Cart', removedAlertMsgs });

        }
    }
}
